import { Col, ProgressBar, Row } from "react-bootstrap";
import { ClockIcons, HistoryIcons } from "../../../../assets/icons/svgicons";
import Card from "../../../common/Card/Card";
import InputFormik from "../../../common/Formik/Input/InputFormik";
import Button from "../../../common/Button/Button";
import arrowupGraph from "../../../../assets/icons/arrowUpgraph.svg";
import style from "./BuyEquity.module.scss";
import Table from "../../../common/Table/Table";
import { useFormik } from "formik";
import * as Yup from "yup";
import { FORMIK_REGEX } from "../../../../utils/constants";
import { Messages } from "../../../../utils/constants";
import { useDispatch, useSelector } from "react-redux";
import {
  getequityTokenDetailsAction,
  getTokenBalanceAction,
  getUserCoinListAction,
  getEquityTransactionsAction
} from "../../../../features/user/userSlice";
import { useEffect, useMemo, useState } from "react";
import { formatPrice, toFix } from "../../../../utils/utils";
import EquityPaymentModal from "./EquityPaymentModal/EquityPaymentModal";
import { validationMessage } from "../../../../Helper/helperfunction";
import { STATUS_CODE } from "../../../../utils/constants";
import { format } from "date-fns";
import Commonpagination from "../../../common/Pagination/Commonpagination";
import { toasts } from "../../../common/Toast/Toast";

const BuyEquity = () => {
  const dispatch = useDispatch();
  const [coinOptions, setCoinOptions] = useState([]);
  const [btcBalance, setBtcBalance] = useState(0);
  const [ethBalance, setEthBalance] = useState(0);
  const [equityToken, setEquityToken] = useState();
  const [equityBalance, setEquityBalance] = useState();
  const [showEquity, setShowEquity] = useState(false);
  const [totalPrice, setTotalPrice] = useState(0);
  const [show, setShow] = useState(false);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState();
  const [coinList, setCoinList] = useState([]);
  const [historytable, setHistoryTable] = useState([]);
  const [decimalLimit, setDecimalLimit] = useState(3);

  const equityPrice = useSelector((state) => state?.users?.equityPrice);






  const getBalance = async () => {
    try {
      const params = {
        tokenId: equityToken?.id,
      };

      const response = await dispatch(getTokenBalanceAction(params));
      const qty = response?.data?.data?.quantity;

      setEquityBalance(Array.isArray(qty) && qty.length === 0 ? 0 : qty ?? 0);

      // setEquityBalance(response?.data?.data?.quantity);
    } catch (error) {
      console.log("error", error);
    }
  };
  const getEquityTokenDetails = async () => {
    try {
      const response = await dispatch(getequityTokenDetailsAction());

      setEquityToken(response?.data?.data?.data);
    } catch (error) {
      console.log("error", error);
    }
  };

  const getEquityTransactionsHistory = async () => {
    const params = { size: 10, page: page };
    try {
      const response = await dispatch(getEquityTransactionsAction(params));
      setTotalPages(response?.data?.data?.totalPages);

      setHistoryTable(response?.data?.data?.transactionList);
    } catch (error) {
      console.log("error", error);
    }
  };
  const fetchCoinOptions = async () => {
    try {
      const response = await dispatch(getUserCoinListAction());
      if (response.data.status === STATUS_CODE.successful) {
        const array = [];
        const newData = response.data.data.coinList;
        setCoinList(newData);
        newData?.map((coin) => {
          array.push({
            value: coin.id,
            label: coin.coin_symbol,
            networkdetails: coin.networkDetail,
            coinImage: coin.coinStats[0]?.image_path,
          });
          if (coin.coin_symbol === "BTC") {
            setBtcBalance(coin.balance);
          }
          if (coin.coin_symbol === "ETH") {
            setEthBalance(coin.balance);
          }
        });
        setCoinOptions(array);
      }
    } catch (error) {
      console.error("Error fetching coin options:", error);
    }
  };


  useEffect(() => {
    getEquityTokenDetails();
    fetchCoinOptions();
    getEquityTransactionsHistory();
  }, [page]);



  const fields = [
    { label: "Date" },
    { label: "Quantity" },
    { label: "Price per Token" },
  ];

  const isSaleInactive = !equityToken || equityToken?.sale_active !== 1;

  const validationSchema = useMemo(
    () =>
      Yup.object({
        quantity: isSaleInactive
          ? Yup.string()
          : Yup.string()
            .required(validationMessage("Quantity"))
            .matches(FORMIK_REGEX.NONZERODECIMAL, Messages?.NONZERODECIMALVALIDATION)
            .test("min-quantity", "Minimum quantity is 1", (val) => {
              if (val !== undefined && val !== "") {
                return parseFloat(val) >= 1;
              }
              return true;
            })
            .test("max-available", "Quantity cannot exceed available tokens", (val) => {
              if (
                val !== undefined &&
                equityToken?.total_supply !== undefined &&
                equityToken?.tokens_sold !== undefined
              ) {
                const availableTokens =
                  equityToken.total_supply - equityToken.tokens_sold;
                return parseFloat(val) <= availableTokens;
              }
              return true;
            }),
      }),
    [
      isSaleInactive,
      equityToken?.total_supply,
      equityToken?.tokens_sold,
    ]
  );

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: {
      quantity: "1",

    },
    validationSchema: validationSchema,
    onSubmit: async (values) => {
      setShow(true);
    },
  });

  // const handleQuantityChange = (e) => {
  //   const filterVal = e.target.value.replace(/[^0-9.]/g, ""); // Remove non-numeric characters
  //   const value = filterVal;
  //   const regex = new RegExp(`^\\d*(\\.\\d{0,${decimalLimit}})?$`);
  //   if (value === "" || regex.test(value)) {
  //     formik.setFieldValue("quantity", value);
  //     setTotalPrice((Number(value || 0) * Number(equityToken?.price || 0)).toFixed(3));
  //   }
  // };

  const handleQuantityChange = (e) => {
    const filterVal = e.target.value.replace(/[^0-9.]/g, "");
    const value = filterVal;
    const regex = new RegExp(`^\\d*(\\.\\d{0,${decimalLimit}})?$`);
    const availableTokens = equityToken?.total_supply !== undefined && equityToken?.tokens_sold !== undefined
      ? equityToken.total_supply - equityToken.tokens_sold
      : Infinity; // Allow input if availableTokens is not yet defined
    if (
      (value === "" || regex.test(value)) &&
      (value === "" ||
        (parseFloat(value) >= 1 && parseFloat(value) <= availableTokens))
    ) {
      formik.setFieldValue("quantity", value);
      const rawTotal = Number(value || 0) * Number(equityToken?.price || 0);
      setTotalPrice(
        rawTotal % 1 === 0
          ? rawTotal.toString()
          : rawTotal.toFixed(4).replace(/\.?0+$/, "")
      );

      //  setTotalPrice(
      //    (Number(value || 0) * Number(equityToken?.price || 0))
      //  );
    }
  };

  useEffect(() => {
    if (equityToken?.price) {
      setTotalPrice((1 * Number(equityToken?.price)));
    }
  }, [equityToken?.price,]);

  useEffect(() => {
    if (equityToken?.id) {
      getBalance();
    }
  }, [equityToken?.id, formik.values.quantity]);


  const handlePurchaseSuccess = async () => {
    try {
      getBalance(); // Refresh balance
      getEquityTransactionsHistory(); // Refresh transaction history
      getEquityTokenDetails();
      formik.resetForm(); // Reset form to initial values
      // setTotalPrice((0.001 * Number(equityToken?.price || 0)).toFixed(3)); // Reset total price
    } catch (error) {
      console.error("Error refreshing data after purchase:", error);
      // toasts.error("Failed to refresh data after purchase");
    }
  };

  const availableTokens =
    equityToken?.total_supply && equityToken?.tokens_sold !== undefined
      ? equityToken.total_supply - equityToken.tokens_sold
      : 0;

  const isSoldOut = availableTokens <= 0;

  const buyNowDisabled =
    !equityToken ||
    equityToken?.sale_active === 0 ||
    isSoldOut ||
    !formik.values.quantity ||
    !!formik.errors.quantity ||
    parseFloat(formik.values.quantity) < 1;

  const saleBadgeLabel = isSaleInactive
    ? "Sale Inactive"
    : isSoldOut
      ? "Sold Out"
      : "Sale Active";

  const saleBadgeClass = isSaleInactive
    ? style.inactive
    : isSoldOut
      ? style.soldOut
      : style.active;

  return (
    <>
      <section className={style.buyEquity}>
        <Row>
          <Col md={12}>
            <div className={style.saleStatus}>
              <h6>
                <span>
                  <ClockIcons />
                </span>
                Sale Status
              </h6>
              <p className={saleBadgeClass}>{saleBadgeLabel}</p>
            </div>
            <Card
              title="Purchase Equity Token"
              className={style.token_purchase}
            >
              <div className={style.token_purchase_inner}>
                <div className={style.token_price}>
                  <h6>
                    <span> </span> Current Token Price
                  </h6>
                  <div className={style.token_price_value}>
                    {/* <h4>{formatPrice(equityToken?.price)}</h4> */}
                    <h4>
                      ${toFix(equityPrice?.price || equityToken?.price, 2)}
                    </h4>

                    <p>per token</p>
                  </div>
                </div>
                <div className={style.token_form}>
                  <Row>
                    <Col md={6}>
                      <InputFormik
                        id="quantity"
                        className={style.input_token}
                        label="Number of Tokens"
                        placeholder={"Enter quantity"}
                        name="quantity"
                        value={formik.values.quantity}
                        onChange={handleQuantityChange}
                        onBlur={formik.handleBlur}
                        formik={formik}
                        disabled={isSaleInactive}
                      // maxLength={10}
                      // blackError
                      />
                    </Col>
                    <Col md={6}>
                      <div className={style.total_price}>
                        <label>Total Amount(USDT)</label>
                        <h5>${toFix(totalPrice, 2)}</h5>
                      </div>
                    </Col>
                  </Row>
                  <Button
                    fluid
                    className={style.buy_button}
                    variant="small_size"
                    onClick={() => setShowEquity(true)}
                    disabled={buyNowDisabled}
                  >
                    Buy Now
                  </Button>
                  <div className={style.tyoken_note}>
                    <p>
                      <span>Note:</span> The minimum purchase is 1 tokens.
                      Please ensure you have sufficient funds in your wallet to
                      complete the transaction.
                    </p>
                  </div>
                  <div className={style.token_progress_bar}>
                    <ProgressBar
                      animated
                      now={
                        equityToken?.total_supply > 0
                          ? (equityToken.tokens_sold /
                            equityToken.total_supply) *
                          100
                          : 0
                      }
                      label={`${equityToken?.total_supply > 0
                        ? (
                          (equityToken.tokens_sold /
                            equityToken.total_supply) *
                          100
                        ).toFixed(2)
                        : "0.00"
                        }%`}
                      max={100}
                    />

                    {/* <ProgressBar
                      animated
                      now={equityToken?.tokens_sold}
                      label={`${equityToken?.tokens_sold}%`}
                      max={equityToken?.total_supply}
                    /> */}
                    <div className={style.token_progress_bar_text}>
                      <p>
                        <span>{equityToken?.tokens_sold}</span> /{" "}
                        {equityToken?.total_supply}
                      </p>
                    </div>
                  </div>
                </div>
                <div className={style.token_balance}>
                  <h6>
                    <span>
                      <img src={arrowupGraph} alt="icon-chart" />
                    </span>{" "}
                    Your Token Balance
                  </h6>
                  <div className={style.token_balance_value}>
                    <h4>{formatPrice(equityBalance)}</h4>
                    <p>In Platform</p>
                  </div>
                </div>
              </div>
            </Card>
          </Col>
          <Col md={12}>
            <Card
              title={
                <>
                  <span>
                    <HistoryIcons />
                  </span>{" "}
                  Purchase History
                </>
              }
              className={style.purchase_history}
            >
              <div className={style.purchase_history_inner}>
                <Table fields={fields} className={"table"}>
                  {historytable.map((item, index) => (
                    <tr key={index}>
                      <td>
                        {format(
                          new Date(item?.created_at),
                          "MMM dd, yyyy hh:mm a"
                        )}
                      </td>
                      <td>{item?.quantity}</td>
                      <td>${toFix(item?.price, 2)}</td>
                    </tr>
                  ))}
                </Table>

                {historytable?.length > 0 && (
                  <Commonpagination
                    // className={classpagonation}
                    currentPage={page}
                    totalPages={totalPages}
                    handlePageChange={(selected) => setPage(selected)}
                  />
                )}
              </div>
            </Card>
          </Col>
        </Row>
      </section>

      <EquityPaymentModal
        equityToken={equityToken}
        quantity={formik.values.quantity}
        ethBalance={ethBalance}
        btcBalance={btcBalance}
        show={showEquity}
        handleClose={() => setShowEquity(false)}
        onPurchaseSuccess={handlePurchaseSuccess}
      />
    </>
  );
};

export default BuyEquity;
